import { Component, OnInit } from '@angular/core';
import { ModalService } from '../../../core/services/modal.service';
import { DataTaskService } from '../../../core/services/data-task.service';
import { BusinesscoItem, LogisticService } from '../../../services/logistic.service';
import { GridOptions } from '../../../core/components/grid/grid.types';
import { Grid } from '../../../core/components/grid/grid.model';

@Component({
  selector: 'tt-accounting-bunts',
  templateUrl: './accounting-bunts.component.html',
  styleUrls: ['./accounting-bunts.component.css']
})
export class AccountingBuntsComponent implements OnInit {
    public setting?: Setting;

    public selectListCompanies: BusinesscoItem[] = [];

    public grid?: GridOptions;

    public creatingNew = false;

    constructor(private modal: ModalService, private datatask: DataTaskService, private logistic: LogisticService) {

    }

    private async loadSetting() {
        this.setting = (await this.datatask.Post(1919))[0];
    }

    private async loadCompanies() {
        this.selectListCompanies = await this.logistic.getCompanies('1');
    }

    private loadGrid() {
        if (!this.setting) return;

        if (!this.grid) {
            this.grid = new Grid().setRememberId(this.setting.view_id).setLoadDataFunction({ method: this.setting.p2_datatask_keyno, parameters: () => this.setting }).setKendoConfig({ height: '100%' }).setToolbar({ wrapping: true });
        } else {
            this.grid?.gridfunc?.read();
        }
    }

    public async createNewChanges() {
        if (!!this.setting) {
            try {
                this.creatingNew = true;

                const response = (await this.datatask.Post(1921, this.setting))[0];

                if (response?.errorcode !== '0') {
                    this.modal.show({
                        type: 'warning',
                        title: 'error',
                        translateTitle: true,
                        message: response.errormessage
                    });
                } else {
                    this.loadGrid();
                }
            } finally {
                this.creatingNew = false;
            }
        }
    }

    public onChanged(_: string, id: keyof Setting) {
        if (!this.setting) return;

        switch (id) {
            case 'businessco_no':
                this.loadGrid();
                break;
            default:
                break;
        }
    }

    private async init() {
        await this.loadSetting();
        this.loadCompanies();
        this.loadGrid();
    }

    ngOnInit() {
        this.init();
    }
}

interface Setting {
    businessco_no: string;
    view_id: string;
    p2_datatask_keyno: number;
}
